// chara.js — global glue
//
// Responsibilities:
//   - quick-add: handle [data-chara-quick-add] clicks on product cards → POST /cart/add.js
//     → refresh cart drawer → open it.
//
// The cart drawer (chara-cart-drawer section) exposes window.charaDrawer = { open, close, refresh }
// and listens for: document.dispatchEvent(new CustomEvent('cart:open' | 'cart:updated', ...))

(function () {
  'use strict';

  document.addEventListener('click', onClick);

  function onClick(e) {
    const btn = e.target.closest('[data-chara-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleQuickAdd(btn);
  }

  async function handleQuickAdd(btn) {
    if (btn.dataset.loading === '1') return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('[chara] quick-add: no variant id on button', btn);
      return;
    }

    const originalHTML = btn.innerHTML;
    btn.dataset.loading = '1';
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span>…</span>';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || 'Quick-add failed');
      }

      // Refresh drawer state (also fires cart:updated for any other listeners)
      if (window.charaDrawer && typeof window.charaDrawer.refresh === 'function') {
        await window.charaDrawer.refresh();
        window.charaDrawer.open();
      } else {
        // Drawer not on the page (shouldn't happen) — fall back to cart page
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }

      btn.innerHTML = '<span>✓</span>';
      setTimeout(() => { btn.innerHTML = originalHTML; }, 1200);
    } catch (err) {
      console.error('[chara] quick-add failed', err);
      btn.innerHTML = '<span>!</span>';
      setTimeout(() => { btn.innerHTML = originalHTML; }, 1500);
    } finally {
      btn.removeAttribute('data-loading');
      btn.removeAttribute('aria-busy');
    }
  }
})();
